(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("WorkHistoryPreviewCtrl", ["$scope", WorkHistoryPreviewCtrl]);
    function WorkHistoryPreviewCtrl($scope) {
        var vm = this;
        vm.model = $scope.$parent.vm.assignment.specificInfo.assignment;
    }
}());
